export default __webpack_public_path__ + "static/media/scalable.5ae838c6.jpeg";